import { render, staticRenderFns } from "./CertificadoEmisionPantalla.vue?vue&type=template&id=45509143&scoped=true&"
import script from "./CertificadoEmisionPantalla.vue?vue&type=script&lang=ts&"
export * from "./CertificadoEmisionPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CertificadoEmisionPantalla.vue?vue&type=style&index=0&id=45509143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45509143",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('45509143', component.options)
    } else {
      api.reload('45509143', component.options)
    }
    module.hot.accept("./CertificadoEmisionPantalla.vue?vue&type=template&id=45509143&scoped=true&", function () {
      api.rerender('45509143', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosEmision/CertificadoEmisionPantalla.vue"
export default component.exports